<template>
  <HLCardLayout disablePadding> <!-- :background="theme.espotoYellow"-->
    <template #title><span class="black--white">{{pageTitle}}</span></template>
    <!-- <template #menuTitle><h3 class="three-dots grey--text text--darken-3" :style="{'color': theme.textColor + '!important'}">{{pageTitle}}</h3></template> -->
    <template #content>
      <div class="text-sm-h6 pt-4 px-4" :style="{'color':theme.textColor}" v-html="pageDescr"/>
    </template>
  </HLCardLayout>
</template>

<script>
import Utils from "../../store/modules/base";
import HLCardLayout from "../../components/dashboard/HLCardLayout.vue";
import {layoutMixin} from "../../utils/layout-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {spotMixin} from "../../utils/spot-mixin";

export default {
  mixins: [layoutMixin,eventMixin,spotMixin],
  components:{
    HLCardLayout
  },
  data(){
    return {
    }
  },
  computed: {
    pageDescr(){
      let content = this.$store.getters['events/getCustomPageContent'](this.$route.params.page_id);
      return Utils.replaceKeywords(content, this.getOfflineStatistic, this.allSpots, this.keywordExtras)
    },
    pageTitle(){
      return this.$store.getters['events/getCustomPageTitle'](this.$route.params.page_id);
    },
  },
  methods: {

  }
}
</script>
